









































import { SearchError, SearchResponse } from '@empathybroker/tsclient-search';

import { mapActions } from 'vuex';

import { ConfigurationsForm, ConfigurationsSearchInput, KeywordsInput } from '../../components';

import { DomainEnum } from '../../enums';

import { ConfigurationsFormMixin } from '../../mixins/configurations-form.mixin';

import { ROUTER_CONSTS } from '../../router/router.consts';

import { SEARCH_CONSTS } from '../../store/search/search.consts';

export default {
  name: 'search-configurations-form',
  mixins: [ConfigurationsFormMixin],
  components: {
    ConfigurationsForm,
    KeywordsInput,
    ConfigurationsSearchInput
  },
  computed: {
    loadSearchDataEnabled: function (): boolean {
      return (
        ConfigurationsFormMixin.computed.loadSearchDataEnabled.bind(this)() &&
        !!this.searchQuery
      );
    },
    searchQuery: function (): string {
      if (!!this.selectedKeyword) {
        let searchQuery = this.selectedKeyword;
        if (!!this.userQuery) {
          searchQuery += ` ${ this.userQuery }`;
        }
        return searchQuery;
      }
    },
    loadPreviewDisabled: function (): boolean {
      return !!this.userQuery;
    }
  },
  data: function () {
    return {
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.configurations[DomainEnum.SEARCH].update),
      item: {
        enabled: true,
        name: undefined,
        context: {
          keywords: [],
          pivots: {}
        },
        ranking: {
          products: {
            elements: []
          },
          attributes: {
            elements: []
          }
        }
      },
      selectedKeyword: undefined,
      userQuery: undefined
    };
  },
  methods: {
    ...mapActions(SEARCH_CONSTS.moduleName, {
      search: SEARCH_CONSTS.actions.search
    }),
    onItemLoad: async function (): Promise<void> {
      this.watchers.searchQuery = this.$watch('searchQuery', this.onSearchQueryWatch);
      await ConfigurationsFormMixin.methods.onItemLoad.bind(this)();
    },
    fetchSearchData: async function (): Promise<SearchResponse | SearchError> {
      return this.search({
        query: this.searchQuery,
        filters: this.searchFilters,
        pagination: this.pagination,
        params: {
          ...this.resultsPreviewParams
        }
      });
    },
    onSearchQueryWatch: async function (): Promise<void> {
      await this.loadSearchData({ resetPagination: true });
    }
  },
  watch: {
    'item.context.keywords': {
      handler: function (keywords: string[]): void {
        if (!this.selectedKeyword || !keywords.includes(this.selectedKeyword)) {
          this.selectedKeyword = this.item.context.keywords[0];
        }
      },
      immediate: true
    }
  }
};

